import {EntityModel} from "@fedeltapointofsale/data-client";
import {AccountData} from "./account.data";
import {Injectable, Injector} from "@angular/core";

/**
 * this is used for add, edit and delete actions for Account

 */
@Injectable()
export class AccountEntityModel extends EntityModel<AccountData> {

    constructor(injector: Injector) {
        super(injector, AccountData);
    }

    override isEntityCloneable(): boolean {
        return false;
    }
}
